module.exports = __webpack_public_path__ + "images/ui-bg_diagonals-thick_18_b81900_40x40.png";